import React, { useState, useRef } from "react";
import {
  GoogleMap,
  useLoadScript,
  Autocomplete,
} from "@react-google-maps/api";

const libraries = ["places"];
const mapContainerStyle = {
  height: "200px",
  width: "100%",
};

const center = {
  lat: 12.99991500,
  lng: 77.62361000,
};

const GoogleMapWithAutocomplete = ({ city, state, apiKey, filterState, setFilterState}) => {
  const [selectedPlace, setSelectedPlace] = useState(null);
  const autocompleteRef = useRef(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries,
  });

  const onPlaceChanged = () => {
  
    const autocomplete = autocompleteRef.current;
    console.log(autocomplete);
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (!place || !place.address_components) return;

      const addressComponents = place.address_components;
      
      const selectedCity = addressComponents.find(comp =>
        comp.types.includes("locality")
      )?.long_name;

      const selectedState = addressComponents.find(comp =>
        comp.types.includes("administrative_area_level_1")
      )?.long_name;

      const pincode = addressComponents.find(comp =>
        comp.types.includes("postal_code")
      )?.short_name;

      const location = String(place.geometry.location).split(',');
      const lat = location[0].replace('(','');

      const lang = location[1].replace(')','');

      if (selectedCity == city && selectedState == state) {
        setSelectedPlace(place);
        setFilterState({...filterState, line2:place.formatted_address, pincode:pincode, latitude:lat, longitude:lang});
      } else {
        alert(`Please select an address in ${city}, ${state}.`);
        // console.log('selectedState  --> '+selectedState);
        // console.log('selectedCity  --> '+selectedCity);
        // console.log('city  --> '+city);
        // console.log('state  --> '+state);
        // console.log(JSON.stringify(addressComponents));
      }
    }
  };

  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";

  return (
    <>
      <Autocomplete
        onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
        onPlaceChanged={onPlaceChanged}
        options={{
          componentRestrictions: { country: "in" },
        }}
      >
        <input
          type="text"
          placeholder={`Enter address in ${city}, ${state}`}
          style={{ width: "100%", padding: "0.5rem", marginBottom: "1rem" }}
        />
      </Autocomplete>

      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={selectedPlace?.geometry?.location || center}
        zoom={selectedPlace ? 15 : 10}
      >
        {/* You can add markers here if needed */}
      </GoogleMap>
    </>
  );
};

export default GoogleMapWithAutocomplete;
